import {useEffect} from 'react';
import {useQuery} from '@apollo/client';
import useScript from '../../util/useScript';
import toggleWebchatDisplay from '../../util/toggleWebchatDisplay';
import trackingEvents from '../../trackingEvents';
import eventMetadata from '../tracking/eventMetadata';
import {IdentityQuery} from '../../hooks/useIdentity';

const useLiveChat = ({trackEvent}) => {
  const chatClient = typeof window !== 'undefined' && window.LibertyWebchatClient;
  const {data} = useQuery(IdentityQuery, {ssr: false});
  const me = data && data.me;
  const catererAccount = me && me.catererAccount;

  const [loadedWebchat] = useScript(
    'https://static.cdn-ezcater.com/liberty-webchat/v12/liberty-webchat.js'
  );
  useEffect(() => {
    if (!catererAccount || !chatClient || !loadedWebchat) return;
    chatClient.load({
      userName: me.catererAccount.name,
      userTrackingId: me.trackingId,
    });
  }, [me, catererAccount, chatClient, loadedWebchat]);

  const openChat = () => {
    if (!chatClient) return;
    trackEvent({
      ...eventMetadata.liveChat,
      event: trackingEvents.OpenLiveChat,
      url: window.location.href,
    });

    toggleWebchatDisplay();

    chatClient.toggleVisibility();
  };

  return openChat;
};

export default useLiveChat;
